import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {useUnlockChoiceLeadFlow} from "../../../hooks/use_unlock_choice_lead_flow";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint} from "../../../types/UnlockChoiceEntryPoint";
import {UnlockChoiceModalLayout} from "./UnlockChoiceModalLayout";

interface IProps {
    entryPoint: UnlockChoiceEntryPoint;
    data: IUnlockChoiceData | null;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onContentOnly: () => void;
    onClose: () => void;
}

export const UnlockChoiceModal = (props: IProps) => {
    const {entryPoint, data} = props;
    const flow = useUnlockChoiceLeadFlow(props);

    return (
        <UnlockChoiceModalLayout
            isOpen={flow.isOpen}
            isLoading={!data}
            entryPoint={entryPoint}
            firstName={flow.firstName}
            price={data?.price ?? null}
            offerType={data?.offerType ?? null}
            vendorName={data?.vendorName ?? null}
            selectedOptionId={flow.selectedOptionId}
            isSending={flow.isSending}
            isConfirmDisabled={flow.isConfirmDisabled}
            confirmation={flow.confirmation}
            isPriceNegotiationShown={flow.isPriceNegotiationShown}
            isPriceNegotiationArmed={flow.isPriceNegotiationArmed}
            onSelectOption={flow.handleSelectOption}
            onConfirm={flow.handleConfirm}
            onClose={flow.handleClose}
            onAfterClose={flow.handleAfterClose}
        />
    );
};
import {IApplicationData} from "../../../../application/types/IApplicationData";
import {ApplicationSource} from "../../../../application/utils/form/application_form_source";
import {useUnlockChoiceLeadFlow} from "../../../hooks/use_unlock_choice_lead_flow";
import {IUnlockChoiceData} from "../../../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint} from "../../../types/UnlockChoiceEntryPoint";
import {UnlockChoiceModalLayout} from "./UnlockChoiceModalLayout";

interface IProps {
    entryPoint: UnlockChoiceEntryPoint;
    data: IUnlockChoiceData | null;
    onLeadSent: (isHomeMatchOn: boolean, sentApplication: IApplicationData | null, leadSource: ApplicationSource) => void;
    onContentOnly: () => void;
    onClose: () => void;
}

export const UnlockChoiceModal = (props: IProps) => {
    const {entryPoint, data} = props;
    const flow = useUnlockChoiceLeadFlow(props);

    return (
        <UnlockChoiceModalLayout
            isOpen={flow.isOpen}
            isLoading={!data}
            entryPoint={entryPoint}
            firstName={flow.firstName}
            price={data?.price ?? null}
            offerType={data?.offerType ?? null}
            vendorName={data?.vendorName ?? null}
            selectedOptionId={flow.selectedOptionId}
            isSending={flow.isSending}
            isConfirmDisabled={flow.isConfirmDisabled}
            confirmation={flow.confirmation}
            isPriceNegotiationShown={flow.isPriceNegotiationShown}
            isPriceNegotiationArmed={flow.isPriceNegotiationArmed}
            onSelectOption={flow.handleSelectOption}
            onConfirm={flow.handleConfirm}
            onClose={flow.handleClose}
            onAfterClose={flow.handleAfterClose}
        />
    );
};
